import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

const LinkBehavior = forwardRef(({ href, ...props }, ref) => (
  <Link ref={ref} to={href} {...props} />
));
LinkBehavior.displayName = 'MuiRouterLink';

export default LinkBehavior;
